 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }import {ConnectionHandler,} from 'relay-runtime'

const getDiscussionThreadConn = (
  store,
  discussionId
) => {
  const viewer = store.getRoot().getLinkedRecord('viewer')
  if (!viewer) return null
  const discussion =
    _nullishCoalesce(viewer.getLinkedRecord('discussion', {id: discussionId}), () => (
    (discussionId && store.get(discussionId))))
  if (!discussion) return null
  return ConnectionHandler.getConnection(discussion, 'DiscussionThread_thread')
}

export default getDiscussionThreadConn
